import { useAppConfiguration } from '#app/hooks/useAppConfiguration.js';
import {
  type RegisterEventAction,
  useSendAnalyticEventMutation,
} from '#app/hooks/useSendAnalyticEventMutation.js';
import { logger } from '#app/services/logger.js';
import { onIdle } from '#app/utilities/onIdle.js';
import { useMount } from '@contra/react-hooks/useMount';
import { isbot } from 'isbot';

const log = logger.child({
  namespace: 'useRegisterAnalyticEvent',
});

export const useRegisterAnalyticEvent = (args?: RegisterEventAction) => {
  const sendAnalyticEventMutation = useSendAnalyticEventMutation();
  const { playwrightTest } = useAppConfiguration();

  useMount(() => {
    if (args) {
      onIdle(() => {
        if (!playwrightTest && isbot(navigator.userAgent)) {
          log.warn('detected bot; skipping useRegisterAnalyticEvent');

          return;
        }

        sendAnalyticEventMutation(args);
      });
    }
  });
};
